// Phase 25 iter-8 — chat client.

import {
  API_VERSION_PREFIX,
  type ConversationDetail,
  type ConversationListResponse,
  type ConversationMessage,
  type CreateConversationResponse,
  type UnreadCountResponse,
} from '@leyrochain/shared';

import { apiClient } from './client';

export async function listConversations(): Promise<ConversationListResponse> {
  const { data } = await apiClient.get<ConversationListResponse>(
    `${API_VERSION_PREFIX}/conversations`,
  );
  return data;
}

export async function openConversation(sale_id: string): Promise<CreateConversationResponse> {
  const { data } = await apiClient.post<CreateConversationResponse>(
    `${API_VERSION_PREFIX}/conversations`,
    { sale_id },
  );
  return data;
}

export async function getConversation(id: string): Promise<ConversationDetail> {
  const { data } = await apiClient.get<ConversationDetail>(
    `${API_VERSION_PREFIX}/conversations/${id}`,
  );
  return data;
}

export async function sendMessage(id: string, text: string): Promise<ConversationMessage> {
  const { data } = await apiClient.post<ConversationMessage>(
    `${API_VERSION_PREFIX}/conversations/${id}/messages`,
    { text },
  );
  return data;
}

export async function markConversationRead(id: string): Promise<void> {
  await apiClient.patch(`${API_VERSION_PREFIX}/conversations/${id}/read`);
}

export async function getUnreadCount(): Promise<UnreadCountResponse> {
  const { data } = await apiClient.get<UnreadCountResponse>(
    `${API_VERSION_PREFIX}/conversations/unread-count`,
  );
  return data;
}
